import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { MenuItem } from 'src/app/layouts/sidebar/menu.model';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { User } from '../models/persons.model';
import { AuthService } from '../services/auth.service';
import { MENU } from './../../layouts/sidebar/menu';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  currentUser: any;
  user: User;
  isUserAll: any;
  isUserAdmin: any;
  constructor(
    private router: Router,
    private authService: AuthService,
    public toastService: ToastService
  ) {
    this.user = this.authService.currentUserValue;
    this.isUserAdmin = this.authService.isUserAdmin;
    this.isUserAll = this.authService.isUserAll;
  }
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
  returnPathIndexMenu(state: any) {
    var path = state.url.split('/');
    return MENU.findIndex((item: MenuItem): boolean | undefined => {
      var hasSubItem = this.hasItems(item);
      if (hasSubItem) {
        item.subItems.forEach((subItem: any) => {
          return subItem.link == '/' + path[1] + '/' + path[2];
        });
      } else {
        return item.link == '/' + path[1];
      }
      return false;
    });
  }

  verifyScreen(state: any) {
    var pathIndex = this.returnPathIndexMenu(state);
    var userScreen = ['1'];
    if (this.currentUser.screensAllowed != undefined) {
      userScreen = this.currentUser.screensAllowed?.split(',');
      if (userScreen[0] == '') {
        userScreen = ['1'];
      }
    }
    var userScreenIndex = undefined;
    try {
      if (MENU[pathIndex].onlyAdmin && this.isUserAdmin) {
        return true;
      } else {
        return false;
      }
    } catch (error) {}
    try {
      userScreenIndex = userScreen?.findIndex((item: any) => {
        if (item == '*' || item == '**' || item == '1') {
          return true;
        }
        return item == MENU[pathIndex].id;
      });
    } catch (error) {}

    if (
      (userScreenIndex != undefined && userScreenIndex > -1) ||
      state.url == '/'
    ) {
      return true;
    }
    return false;
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.currentUser = this.user
      ? this.user
      : localStorage.getItem('currentUser') != null
      ? JSON.parse(
          this.authService.decrypt(
            localStorage.getItem('currentUser')!?.toString()
          )
        )
      : null;

    if (this.currentUser) {
      if (new Date(this.currentUser.token.accessExpires) < new Date()) {
        if (
          new Date().getDay() ==
          new Date(this.currentUser.token.accessExpires).getDay()
        ) {
          this.toastService.show('Tempo expirado, faça o login novamente!', {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        }
        this.authService.disallow().subscribe(() => {
          return this.authService.logout();
        });
      }
      if (!this.verifyScreen(state)) {
        this.router.navigate(['/']);
      }
      return this.verifyScreen(state);
    } else {
      state.url == '/' ? (state.url = '') : (state.url = '/');
      this.router.navigate(['/auth/login']);
      return true;
    }
  }
}
